import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  // catalog (Shopify-backed)
  getCategories: () => client.get("/categories").then((r) => r.data),
  getProducts: (params = {}) => client.get("/products", { params }).then((r) => r.data),
  getProduct: (slug) => client.get(`/products/${slug}`).then((r) => r.data),
  getProductTypes: () => client.get("/product-types").then((r) => r.data),

  // reviews (custom)
  getReviews: (params = {}) => client.get("/reviews", { params }).then((r) => r.data),
  getReviewsSummary: () => client.get("/reviews/summary").then((r) => r.data),
  createReview: (payload) => client.post("/reviews", payload).then((r) => r.data),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },

  // marketing / content
  getTestimonials: () => client.get("/testimonials").then((r) => r.data),
  getStats: () => client.get("/stats").then((r) => r.data),
  createPartnerLead: (payload) => client.post("/leads/partner", payload).then((r) => r.data),
  createWhiteLabelLead: (formData) =>
    client.post("/leads/whitelabel", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  createContact: (payload) => client.post("/contact", payload).then((r) => r.data),
  subscribeNewsletter: (payload) => client.post("/newsletter", payload).then((r) => r.data),

  // checkout (Shopify hosted checkout) + storefront config
  createCheckout: (payload) => client.post("/checkout/create", payload, { withCredentials: true }).then((r) => r.data),
  getConfig: () => client.get("/config").then((r) => r.data),

  // customer account (Shopify New Customer Accounts via backend OAuth)
  accountMe: () => client.get("/account/me", { withCredentials: true }).then((r) => r.data),
  accountOrders: () => client.get("/account/orders", { withCredentials: true }).then((r) => r.data),
  accountAddresses: () => client.get("/account/addresses", { withCredentials: true }).then((r) => r.data),
  accountLogout: () => client.post("/account/logout", {}, { withCredentials: true }).then((r) => r.data),
  accountLoginUrl: (returnTo = "/account") => `${API}/account/login?returnTo=${encodeURIComponent(returnTo)}`,

  // mobile OTP auth (MessageBot SMS) — shares the same session cookie as above
  sendOtp: (payload) => client.post("/auth/send-otp", payload, { withCredentials: true }).then((r) => r.data),
  verifyOtp: (payload) => client.post("/auth/verify-otp", payload, { withCredentials: true }).then((r) => r.data),
  completeProfile: (payload) => client.post("/auth/complete-profile", payload, { withCredentials: true }).then((r) => r.data),
};

export default api;
